/**
 * Redux store for /create-video-new editor
 */

import { configureStore } from '@reduxjs/toolkit';
import assetsReducer from './slices/assetsSlice';
import timelineReducer from './slices/timelineSlice';
import playbackReducer from './slices/playbackSlice';
import editorUIReducer from './slices/editorUISlice';
import recordingReducer from './slices/recordingSlice';
import undoRedoReducer from './slices/undoRedoSlice';
import uploadProgressReducer from './slices/uploadProgressSlice';
import mobileUploadReducer from './slices/mobileUploadSlice';
import { undoRedoMiddleware } from './middleware/undoRedoMiddleware';

export const store = configureStore({
  reducer: {
    assets: assetsReducer,
    timeline: timelineReducer,
    playback: playbackReducer,
    editorUI: editorUIReducer,
    recording: recordingReducer,
    undoRedo: undoRedoReducer,
    uploadProgress: uploadProgressReducer,
    mobileUpload: mobileUploadReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(undoRedoMiddleware),
});

export default store;

